import {Directive, HostListener, Input, OnDestroy} from '@angular/core'
import {DialogContext, DialogService} from '../../../craft/dialog/dialog.service'
import {takeUntil} from 'rxjs/operators'
import {ContactDialog_CreateLeadGql} from '../../../../__generated__/types'
import {SendMessageEvent} from '../../../craft/contact-form-card/contact-form-card.types'
import {Router} from '@angular/router'
import {Subject} from 'rxjs'
import {ContactForm} from '../../../core/content/types/contact-form.types'
import {ContactFormCardDialogComponent} from '../../../craft/contact-form-card/contact-form-card-dialog-component'

@Directive({
  selector: '[bgoOpenContactModal]',
})
export class OpenContactModalOnClickDirective implements OnDestroy {
  @Input({required: true}) dataPrivacyLink!: string
  @Input({required: true}) contactForm!: ContactForm
  @Input() timeout = 1500

  private readonly unsubscribe$ = new Subject<void>()

  constructor(
    private readonly dialogService: DialogService,
    private readonly router: Router,
    private readonly gql: ContactDialog_CreateLeadGql,
  ) {}

  ngOnDestroy() {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }

  @HostListener('click')
  onClick() {
    const ctx = this.dialogService.show(ContactFormCardDialogComponent, {
      dataPrivacyLink: this.dataPrivacyLink,
      alternativeCallToAction: this.contactForm,
      sendMessage: (e: SendMessageEvent) => this.onSendMessage(e, ctx),
    })
  }

  private onSendMessage(e: SendMessageEvent, dialog: DialogContext<ContactFormCardDialogComponent, void>) {
    // intercept the done() fn to automatically close the dialog a few milliseconds after success.
    const done = e.done
    e.done = () => {
      done()
      setTimeout(() => dialog.close(), this.timeout)
    }

    this.sendClientMessage(e)
  }

  private sendClientMessage(e: SendMessageEvent) {
    this.gql
      .mutate({
        req: {
          ...e.fields,
          referrer: this.router.url,
        },
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(r => {
        if (r.data?.createLead.success) {
          e.done()
        }
      })
  }
}
